import { render, staticRenderFns } from "./UniversityHead.vue?vue&type=template&id=62972bfc&scoped=true&"
import script from "./UniversityHead.vue?vue&type=script&lang=js&"
export * from "./UniversityHead.vue?vue&type=script&lang=js&"
import style0 from "./UniversityHead.vue?vue&type=style&index=0&id=62972bfc&scoped=true&lang=less&"
import style1 from "./UniversityHead.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62972bfc",
  null
  
)

export default component.exports